<template>
      <div class='webform'>
        <div class="card-content" v-show='showMessageForm'>
          <div style='margin-bottom: 10px'>
            <b class='big-font'>Your mobile phone:</b>
          </div>
          <b-field 
            :type="type"
            placeholder="Phone..."
                  :message="message">
                  <b-input
                    @input='validatePhone'
                    icon='cellphone-basic'
                    :loading='isValidationInProgress'
                    v-model='recipientPhone'>
                  </b-input>
          </b-field>
          <div style='margin-bottom: 10px'>
            <b class='big-font'>Your message:</b>
          </div>
          <b-field class='mb-01'>
            <b-input 
              maxlength="160" 
              placeholder="Your message..."
              type="textarea" 
              v-model='messageBody'>
            </b-input>
          </b-field>
          <br>

          <div style='margin-top: 20px;'>
            <center>
              <vue-recaptcha
                class='mb-3'
                v-if='!isHuman'
                :sitekey="gKey"
                @verify="onVerify">
              </vue-recaptcha>
              <a v-show='submittable' class="is-link mb-3" @click='submit'>
                <img src='/send.png'>
              </a>
              <center v-show='!submittable && isHuman' class='has-text-danger'>
                <small>Fill in all fields to be able to send a message!</small>
              </center>

            </center>
          </div>
        </div>
        
        <div class="card-content" v-show='!showMessageForm'>
          <center>
            <div v-show='showSuccess'>
              <strong class='has-text-success'>Message Successfully sent!</strong>
            </div>
            <div v-show='showFail'>
              <strong class='has-text-danger'>Failed to send message!</strong>
            </div>
          </center>
        </div>
      </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
  created: function() {
    this.eventHub.$on('Button pressed', this.modalButtonPressed)
  },
  components: { VueRecaptcha },
  name: 'app',
  props: {trackingNumber: String, autoAnswer: {default: false}, gKey: {default: '6Ld1vFIUAAAAAGmvOTyimnQbOMtUF4zF28XJFfUX'}},
  data: function() {
    return {
      message: 'Phone number is incorrect',
      type: 'is-danger',
      isHuman: false,
      isValidationInProgress: false,
      recipientPhone: null,
      validatedRecipientPhone: null,
      messageBody: null,
      showSuccess: false,
      showFail: false,
      isModalActive: false
    }
  },
  methods: {
    onVerify:   function (response) {
      if (response) {
        this.isHuman = true
      }
    },
    validatePhone() {
      if(this.recipientPhone.length > 9) {
        this.isValidationInProgress = true
        this.$http.get('https://yelpdash.com/api/v1/sms', 
          {params: {phone_number: this.recipientPhone}}).then(response => {
            this.isValidationInProgress = false
            if(response.body.validatedNumber) {
              this.validatedRecipientPhone = response.body.validatedNumber
              this.message = null
              this.type = 'is-success'
            } else {
              this.resetField();
            }
          }, response => {
            this.isValidationInProgress = false
            this.resetField();
          })
      }
    },
    resetField() {
      this.validatedRecipientPhone = null
      this.message = 'Phone number is incorrect'
      this.type = 'is-danger'
    },
    submit() {
      var params = {
        from_number: this.validatedRecipientPhone,
        to_number: this.trackingNumber,
        message: this.messageBody,
        auto_answer: this.autoAnswer
      }
      this.$http.post('https://yelpdash.com/api/v1/sms', params, { headers: { "content-type": "application/json" } }).then(response => {
        if (response.body.sent) {
          this.showSuccess = true
        } else {
          this.showFail = true
        }
      }, response => {
        this.showFail = true
      })

    },
    modalButtonPressed() {
      this.isModalActive = true
    }
  },
  computed: {
    submittable() {
      return (this.isHuman && this.validatedRecipientPhone && this.messageBody)
    },
    showMessageForm() {
      return (!this.showSuccess && !this.showFail)
    }
  }
}
</script>

<style lang="scss" scoped>
.webform  {
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 30px;
 	color: #eee;
 	font-size: 0.9em;
}
.big-font {
 	text-transform: uppercase;
 	letter-spacing: 2px;
}

#app {
	input, select, option, textarea {
		border: 1px solid #ddd;
		padding: 6px 15px;
		border-radius: 5px;
    transition: all .5s;
	}
	input:hover,textarea:hover {
		box-shadow: 0 0 10px 1px #4CAF50;
	}
  .mb-0 {
    margin-bottom: -20px;
  }

  .mb-01 {
    margin-bottom: -30px;
  }

  .mt-0 {
    margin-top: -20px;
  }

  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
  .mt-3 {
    margin-top: 10px;
  }
  .mb-3 {
    margin-bottom: 10px;
  }
  .ml-3 {
    margin-left: 10px;
  }
  .center {
    text-align: center !important;
  }
  .grey {
    color: grey !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/form.vue